var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-background",style:({ 'background-color': _vm.backgroundColor })})
}
var staticRenderFns = []

export { render, staticRenderFns }